import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAlert } from 'react-alert';
import Masonry from 'react-masonry-css';
import ProductBlock from 'shared/components/likiee/ProductBlock';
import SkeletonLoader from 'shared/components/ui/SkeletonLoader';
import { ArrowLeftLargeIcon, FolderIconFilled, TrashIconFilled } from 'shared/components/Icons';
import { getError } from 'utils/appHelpers';
import { API, graphqlOperation } from 'aws-amplify';
import { getCategoryLikees } from 'graphql/projects/queries';
import { removeProductModal } from 'shared/utils/productHelpers';
import SaveToProjectModal from 'shared/components/likiee/SaveToProjectModal';
import { useDispatch, useSelector } from 'react-redux';
import { onSetProjectItems } from '../../actions/projectItems';
import { getLocalizedPath } from 'utils/languageHelpers';

const CategoriesProducts = ({ match, history }) => {
  const dispatch = useDispatch();
  const [productForProject, setProductForProject] = useState(false);
  const projectItems = useSelector(state => state.projectItems);
  const { t } = useTranslation();
  const alert = useAlert();
  const categoryTag = match.params?.id;
  const categoryName = match.params?.name;
  const [products, setProducts] = useState(projectItems[categoryTag]);

  const goBack = () => {
    history.goBack();
  };

  const getCategoryData = async () => {
    try {
      const input = { limit: 1000, categoryTag: categoryTag };
      const products = await API.graphql(graphqlOperation(getCategoryLikees, input));
      setProducts(products.data.getCategoryLikees.items);
      dispatch(onSetProjectItems({ projectID: categoryTag, body: products.data.getCategoryLikees.items }));
    } catch (err) {
      alert.error(getError(err));
    }
  };

  const onProductClick = product => {
    const id = product.likiee?.id || product.id;
    history.push(getLocalizedPath(`/likiee/${id}`));
  };

  const onProductRemove = product => {
    removeProductModal(product, alert, t, getCategoryData);
  };

  useEffect(() => {
    getCategoryData();
  }, [categoryTag]);

  return (
    <div className='products-page pb-10'>
      <div className='d-flex align-items-center justify-content-between mb-10 mb-md-15'>
        <div>
          <h1 className='d-flex align-items-center mb-3'>
            <button className='btn p-0 mr-5' onClick={goBack}>
              <ArrowLeftLargeIcon />
            </button>
            <span>{categoryName}</span>
          </h1>
          <p className='mb-0 text-gray-dark pl-23 d-none d-md-block'>
            {products?.length || 0} {t('text_products')}
          </p>
        </div>
      </div>
      {!products ? (
        <SkeletonLoader type='product-grid' count={8} />
      ) : (
        <>
          {!!products?.length && (
            <Masonry
              breakpointCols={{
                default: 4,
                1100: 3,
                500: 2,
              }}
              className='recomended-items-grid pl-6 pl-md-0'
              columnClassName='recomended-items-grid-column'
            >
              {products?.map((item, i) => {
                const actionButtons = [
                  { logo: <TrashIconFilled />, onClick: onProductRemove.bind(null, item) },
                  {
                    logo: <FolderIconFilled />,
                    onClick: setProductForProject.bind(null, item),
                  },
                ];
                return (
                  <ProductBlock
                    product={item}
                    key={i}
                    actionButtons={actionButtons}
                    showAlarm={true}
                    showDate={true}
                    notAvailable={item.availability === 'OutOfStock'}
                    onProductClick={onProductClick.bind(null, item)}
                  />
                );
              })}
            </Masonry>
          )}
          {!products?.length && (
            <div className='text-center mt-70'>
              <p>{t('no_product_in_project')}</p>
            </div>
          )}
        </>
      )}
      {productForProject && (
        <SaveToProjectModal
          productID={productForProject.id}
          initialProjectIDs={productForProject.projects?.items.map(i => i.id) || []}
          onClose={() => {
            setProductForProject(false);
          }}
          onSuccess={getCategoryData}
        />
      )}
    </div>
  );
};

export default CategoriesProducts;
